import { render, staticRenderFns } from "./NewConversationDialog.vue?vue&type=template&id=2f9f6a65&scoped=true"
import script from "./NewConversationDialog.vue?vue&type=script&lang=js"
export * from "./NewConversationDialog.vue?vue&type=script&lang=js"
import style0 from "./NewConversationDialog.vue?vue&type=style&index=0&id=2f9f6a65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f6a65",
  null
  
)

export default component.exports